<template>
  <div>
    <a-modal
      v-model="newUserModalVisible"
      title="new user"
      @ok="handleCreateUser"
      @cancel="() => toggleUserModal()"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="Username">
          <a-input
            v-decorator="[
              'username',
              {
                rules: [{ required: true, message: 'Please input username!' }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="First Name">
          <a-input
            v-decorator="[
              'firstName',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Last Name">
          <a-input
            v-decorator="[
              'lastName',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Email">
          <a-input
            v-decorator="[
              'email',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Phone">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Gender">
          <a-select
            v-decorator="[
              'sex',
              {
                rules: [{ required: true, message: 'Please select gender!' }],
              },
            ]"
            placeholder="Select gender"
          >
            <a-select-option value="MAN">
              male
            </a-select-option>
            <a-select-option value="WOMAN">
              female
            </a-select-option>
            <a-select-option value="UNKNOWN">
              unknown
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Applications">
          <a-select
            v-decorator="[
              'apps',
              {
                rules: [
                  { required: true, message: 'Please select application !' },
                ],
              },
            ]"
            mode="multiple"
            placeholder="Please select application"
          >
            <a-select-option v-for="i in apps" :key="i._id">
              {{ i.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Active">
          <a-switch
            default-checked
            v-decorator="[
              'active',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <!-- <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            Submit
          </a-button>
        </a-form-item> -->
      </a-form>
    </a-modal>
    <UserDetails ref="user-detail-window" :user="selectedUser" />
    <a-table
      :columns="columns"
      :row-key="(record) => record._id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
      size="small"
    >
      <template slot="title">
        <a-space>
          <a-input-search
            placeholder="search users by username,email,phone ..."
            style="width: 500px"
            enter-button
            size="small"
            @search="onSearch"
          />

          <a-button
            @click="() => fetch()"
            type="dark"
            shape="round"
            icon="reload"
            size="small"
            >reload</a-button
          >

          <a-button
            @click="toggleUserModal"
            type="default"
            class="bg-success"
            shape="round"
            icon="user-add"
            size="small"
            >create user</a-button
          >
        </a-space>
      </template>

      <template slot="username" slot-scope="username">
        <strong
          class="text-primary"
          @click="copy(username)"
          style="cursor:pointer;"
          title="copy"
        >
          {{ username }}
        </strong>
      </template>
      <template slot="bool" slot-scope="bool">
        <a-icon v-if="bool" type="check-circle" class="text-success" />
        <a-icon v-if="!bool" type="close-circle" class="text-danger" />
      </template>
      <template slot="date" slot-scope="date">
        <a-tag color="orange">
          {{ momentom(date) }}
        </a-tag>
      </template>

      <template slot="actions" slot-scope="record">
        <a-button
          type="primary"
          icon="setting"
          size="small"
          shape="round"
          @click="() => openUserSettings(record)"
        >
          setting
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import UserDetails from "./UserDetails.vue";
import { copyTextToClipboard } from "../../utils/common";
export default {
  components: { UserDetails },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this, { name: "coordinated" }),
      apps: [],
      userDetailsVisible: false,
      selectedUser: {},
      newUserModalVisible: false,
      columns: [
        // {
        //   title: "Name",
        //   dataIndex: "name",
        //   sorter: true,
        //   width: "20%",
        //   scopedSlots: { customRender: "name" },
        // },
        // {
        //   title: "Gender",
        //   dataIndex: "gender",
        //   filters: [
        //     { text: "Male", value: "male" },
        //     { text: "Female", value: "female" },
        //   ],
        //   width: "20%",
        // },
        {
          title: "",
          scopedSlots: { customRender: "actions" },
          width: "1%",
        },
        {
          title: "username",
          dataIndex: "username",
          sorter: true,
          scopedSlots: { customRender: "username" },
        },
        {
          title: "email",
          sorter: true,
          dataIndex: "email",
        },
        {
          title: "phone",
          sorter: true,
          dataIndex: "phone",
        },
        {
          title: "firstName",
          sorter: true,
          dataIndex: "firstName",
        },
        {
          title: "lastName",
          sorter: true,
          dataIndex: "lastName",
        },
        {
          title: "sex",
          sorter: true,
          dataIndex: "sex",
        },
        {
          title: "enable2fa",
          sorter: true,
          dataIndex: "enable2fa",
          scopedSlots: { customRender: "bool" },
        },
        {
          title: "createdAt",
          dataIndex: "createdAt",
          sorter: true,
          scopedSlots: { customRender: "date" },
        },
        {
          title: "active",
          dataIndex: "active",
          sorter: true,
          scopedSlots: { customRender: "bool" },
        },

        // {
        //   title: "",
        //   dataIndex: "",
        // },
        // {
        //   title: "",
        //   dataIndex: "",
        // },
        // {
        //   title: "",
        //   dataIndex: "",
        // },
      ],
      pagination: {},
      data: [],
      loading: null,
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      const params = {
        pageSize: pagination.pageSize,
        page: pagination.current,
        ...filters,
      };
      if (sorter.order) {
        params.sort =
          sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      }
      this.fetch(params);
    },
    fetch(params = {}) {
      this.loading = true;
      this.axios
        .get("/api/users", {
          params: {
            //results: 10,
            ...params,
          },
        })
        .then(({ data }) => {
          const pagination = { ...this.pagination };
          // Read total count from server
          pagination.total = data.total;
          this.loading = false;
          this.data = data.rows;
          this.pagination = pagination;
        });
    },
    momentom(input) {
      let date = moment(input);
      return date.fromNow();
    },
    copy(text) {
      copyTextToClipboard(text);
      this.$message.info("copied !");
    },
    onSearch(t, e) {
      if (t) {
        this.fetch({
          searchFields: ["username", "email", "phone", "firstName", "lastName"],
          search: t,
        });
      } else {
        this.fetch({});
      }
    },
    toggleUserModal() {
      this.newUserModalVisible = !this.newUserModalVisible;
    },
    handleCreateUser() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.axios
            .post("/api/users", values)
            .then(({ data }) => {
              this.$message.info("user created successfully !");
              this.fetch();
              this.toggleUserModal();
              this.form = this.$form.createForm(this, { name: "coordinated" });
            })
            .catch((err) => {});
          console.log("Received values of form: ", values);
        }
      });
    },
    loadApps() {
      this.axios
        .get("/public/auth/apps")
        .then(({ data }) => {
          this.apps = data.rows;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === "male" ? "man" : "lady"}!`,
      });
    },
    openUserSettings(user) {
      console.log(user);
      this.userDetailsVisible = true;
      this.selectedUser = user;
      this.$refs["user-detail-window"].toggle();
    },
  },
  mounted() {
    this.fetch();
    this.loadApps();
  },
};
</script>
